import { SafeAreaView, StyleSheet, ScrollView, Platform, RefreshControl, View, KeyboardAvoidingView, Dimensions, useWindowDimensions } from 'react-native';
import React, { useState, useEffect } from 'react';
import CustomLabel from '../../CustomLabel/CustomLabel';
import CustomDropDownWithIcons from '../../CustomDropDownWithIcons';
import CustomInput from '../../CustomInput';
import { useAccountContext } from '../../../hooks/useAccountContext';
import CustomButton from '../../CustomButton';
import { useTheme } from '@react-navigation/native';
import { Card } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useAssessment } from '../../../hooks/useAssessment';
import { showMessage } from 'react-native-flash-message';
import { Checkbox } from 'react-native-paper';
var width = Dimensions.get('window').width;

const CustomGroup = ({ group, setGroup, isEdit = 0, isResponse = 0, isResult = 0,
    setShowResponseScreen, setShowMyAssessments, setShowEditGroup, setShowAssessmentsAdmin, setShowCreateGroup, setShowCreateScreen, setShowEditScreen, isCreate = 0 }) => {

    const { user, clientApi } = useAuthContext();
    const { width, height } = useWindowDimensions()
    const { account } = useAccountContext();
    const { postGroup } = useAssessment();
    const token = user.token;
    const { colors } = useTheme();
    const styles = makeStyles(colors, width, height);
    const { t } = useTranslation();
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );

    // ! --------------------------------
    // ! Group
    // * Change Group Title
    const handleGroupTitleChange = (e) => {
        const list = {
            assmgroupUI: group.assmgroupUI, organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625", description: e, locked: group.locked, require_login: true
        }
        setGroup(list)
        //console.log(list)
    }

    // * Change Group Locked
    const handleGroupLockedChange = (e) => {
        //console.log(e)
        const list = {
            assmgroupUI: group.assmgroupUI, organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625", description: group.description, locked: !group.locked, require_login: true
        }
        setGroup(list)
        //console.log(list)
    }

    // * Save Group
    const handleSaveGroup = async () => {
        console.log("Saving...")
        //console.log(group)

        if (group.description == "") {
            showMessage({
                message: 'Please enter group title',
                type: "error",
                duration: 3000,
            });
            return;
        }

        await postGroup(clientApi, token, group, account.employeeId, isEdit)
            .then(response => {
                showMessage({
                    message: 'Group successfully saved!',
                    type: "success",
                    duration: 3000,
                });
                if (!isCreate) {
                    setShowMyAssessments(1)
                    setShowResponseScreen(0);
                    setShowCreateScreen(0);
                    setShowEditGroup(0);
                    setShowCreateGroup(0);
                    setShowEditScreen(0);
                } else {
                    setShowAssessmentsAdmin(1)
                    setShowResponseScreen(0);
                    setShowCreateScreen(0);
                    setShowCreateGroup(0);
                    setShowEditGroup(0);
                    setShowEditScreen(0);
                }
            })
            .catch(error => {
                showMessage({
                    message: 'Group failed to save',
                    type: "error",
                    duration: 3000,
                });
                if (!isCreate) {
                    setShowMyAssessments(1)
                } else {
                    setShowAssessmentsAdmin(1)
                }
                setShowCreateScreen(0)
                setShowEditScreen(0)
                setShowResponseScreen(0)
                setShowEditGroup(0)
                setShowCreateGroup(0)
                return false;
            })
    }

    // * Cancel Group Creation
    const handleCancelGroup = () => {
        console.log("Cancel..")
        if (!isCreate)
            setShowMyAssessments(1)
        else
            setShowAssessmentsAdmin(1)
        setShowResponseScreen(0);
        setShowCreateScreen(0);
        setShowCreateGroup(0);
        setShowEditGroup(0);
        setShowEditScreen(0);
    }

    return (
        <SafeAreaView style={styles.main}>
            <Card style={styles.cardstyle} >
                <Card.Actions>
                    <SafeAreaView style={styles.inputContainer}>
                        {/*<CustomLabel
                            value={t('common:grouptitle')}
                            type='ASSM'
                        />*/}
                        <CustomInput
                            value={group.description === "" || group.description === undefined ? '' : group.description}
                            setValue={handleGroupTitleChange}
                            type='MYPROFILE'
                            placeholder={isEdit === 1 ? group.description : `${t('common:grouptitle')}...`}
                        />
                    </SafeAreaView>
                </Card.Actions>
                <Card.Actions>
                    <SafeAreaView style={styles.modalCheckBoxRow}>
                        <CustomLabel
                            value={t('common:lockgroup')}
                            type='CHECKBOXLABEL' />
                        <Checkbox
                            status={group.locked === "" ? group.locked = false : group.locked ? 'checked' : 'unchecked'}
                            onPress={handleGroupLockedChange}
                        />
                    </SafeAreaView>
                </Card.Actions>
            </Card>
            {/* Assessment Save and Cancel Buttons */}
            <Card style={styles.cardButtons} >
                <Card.Actions>
                    <SafeAreaView style={styles.actions} >
                        <SafeAreaView style={styles.modalButtonsRow}>
                            <CustomButton
                                text={Platform.OS === 'web' && width > 1300 ? t('common:cancel') : ''}
                                onPress={() => handleCancelGroup()}
                                iconName="close-circle-outline"
                                show='SURVEYREJECT'
                                type='SURVEYREJECT'
                                textTop='0'
                                sz={25}
                            />
                            {/* Save Button */}
                            <CustomButton
                                text={Platform.OS === 'web' && width > 1300 ? (isEdit ? t('common:updategroup') : t('common:save')) : ''}
                                onPress={() => handleSaveGroup()}
                                iconName="save-outline"
                                show='SURVEY'
                                type='SURVEY'
                                textTop='0'
                                sz={25}
                            />
                        </SafeAreaView>
                    </SafeAreaView>
                </Card.Actions>
            </Card>
        </SafeAreaView>
    )
}

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
        alignItems: 'center',
        padding: '10%',
    },
    inputContainer: {
        flex: 1,
        width: '100%',
        justifyContent: 'flex-start',
    },
    modalButtonsRow: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginRight: Platform.OS === 'web' && width > 1300 ? 0 : 40,
        marginBottom: 20,
    },
    modalCheckBoxRow: {
        flex: 1,
        margin: 5,
        marginRight: Platform.OS === 'web' && width > 1300 ? width * 60 / 100 : 40,
        flexDirection: 'row',
    },
    cardButtons: {
        padding: 10,
        margin: 10,
        width: Platform.OS === 'web' && width > 1300 ? width - (width * 30 / 100) : width * 80 / 100,
        borderRadius: 35,
        alignContent: 'flex-end',
        backgroundColor: colors.background_card,
        elevation: 10,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
    },
    actions: {
        width: Platform.OS === 'web' && width > 1300 ? width - (width * 35 / 100) : width * 80 / 100,
        justifyContent: 'center',
        alignItems: 'flex-end'
    },
    cardstyle: {
        padding: 10,
        margin: 10,
        width: Platform.OS === 'web' && width > 1300 ? width - (width * 30 / 100) : width * 80 / 100,
        borderRadius: 35,
        backgroundColor: colors.background_card,
        elevation: 10,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
    },
});

export default CustomGroup; 